import { Component, OnInit } from '@angular/core';
import { LoaderService } from 'app/loader.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Angulartics2 } from 'angulartics2';
import { FilesService } from 'app/files.service';
var MarkdownIt = require('markdown-it');
var md = new MarkdownIt({html: true});

@Component({
  selector: 'app-pages',
  templateUrl: './pages.component.html',
  styleUrls: ['./pages.component.scss']
})
export class PagesComponent implements OnInit {

  pageId: string = null;
  pageContent: string = null;
  markDown: string = null;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private loaderService: LoaderService,
    private angulartics2: Angulartics2,
    private filesService: FilesService
  ) { }

  ngOnInit() {
    this.pageId = this.route.snapshot.params.id;
    this.showContent();
    this.loaderService.setLoaded();
  }

  /**
  * ---------------------------------------------
  * Load and output the static file content into `pageContent`
  * ---------------------------------------------
  */
  showContent(){
    if (!this.pageId) {
      this.pageContent = 'Content unavailable';
    } else {
      this.filesService.getTextFile('assets/files/' + this.pageId)
      .subscribe(
        response => {
          if(response['_body'].toString().includes('<!doctype html>')){throw new Error("Content unavailable");} // TODO: this is a complete hack
          this.pageContent = md.render(response['_body'].toString());
        },
        error => {
          this.pageContent = md.render("### 404, Sorry we can't find that page");
        }
      )
    }
    this.loaderService.setLoaded();
  }

}



// WEBPACK FOOTER //
// /tmp/build_769bc651/src/app/pages/pages.component.ts